





























































































































































































































































































































import "vue-phone-number-input/dist/vue-phone-number-input.css";
import PhoneNumberInput from "vue-phone-number-input";
import Results from "@/components/Results.vue";
import Spinner from "vue-simple-spinner";
import _ from "lodash";
import assert from "assert";
import sleep from "sleep-promise";
import { Election, Voter, Vue } from "@/types.ts";

export default Vue.extend({
  components: {
    PhoneNumberInput,
    Results,
    Spinner,
  },
  computed: {
    election(): Election | null {
      return this.elections?.get(this.uuid) || null;
    },
    elections(): Map<string, Election> | null {
      const state = this.$store.state;
      assert(state.electionsTracker);
      return state.elections;
    },
    email(): string | null {
      const email = this.$route.query["email"] || null;
      if (Array.isArray(email)) return email[0] || null;
      else return email || null;
    },
    pub(): string | null {
      const pub = this.$route.query["pub"] || null;
      if (Array.isArray(pub)) return pub[0] || null;
      else return pub || null;
    },
    tooLate(): boolean {
      return (this.election?.end && this.election?.end < new Date()) || false;
    },
    tooSoon(): boolean {
      return (
        (this.election?.start && this.election?.start > new Date()) || false
      );
    },
    voter(): Voter | null {
      if (!this.election) return null;
      return (
        _.find(this.election.voters, voter => voter.email === this.email) ||
        null
      );
    },
  },
  data(): {
    answers: Array<[boolean | null, Array<boolean>]> | null;
    ballot: string | null;
    code: string;
    codeStatus: undefined | null | string;
    data: string;
    failure: string | null;
    fallbackPhone: string | null;
    fallbackPhoneInput: string;
    fingerprint: string | null;
    priv: string | null;
    status: string | null;
    step: number | null;
    transition: string;
  } {
    return {
      answers: null,
      ballot: null,
      code: "",
      codeStatus: undefined,
      data: "",
      failure: null,
      fallbackPhone: null,
      fallbackPhoneInput: "",
      fingerprint: null,
      priv: null,
      step: null,
      status: null,
      transition: "slide-right",
    };
  },
  methods: {
    arity(min: number, max: number): string {
      if (min == max) return this.$tc("_vote.exactly", min).toString();
      else return this.$tc("_vote.between", max, { min, max }).toString();
    },
    picksCount(step: number): number {
      return this.answers ? _.filter(this.answers[step][1]).length : 0;
    },
    async getCode(): Promise<void> {
      this.codeStatus = null;
      const address = await this.$store.dispatch("getCode", {
        election: this.election,
        fallbackPhone: this.fallbackPhone,
        voter: this.voter,
      });
      this.codeStatus = `Le code a été envoyé à ${address}`;
    },
    next(): void {
      this.failure = null;
      this.transition = "slide-right";
      if (this.step == null) this.step = 0;
      else this.step++;
    },
    prev(): void {
      if (this.step == null) return;
      this.transition = "slide-left";
      if (this.step == 0) this.step = null;
      else this.step--;
    },
    retry() {
      this.failure = null;
      this.status = null;
    },
    setFallbackPhone({
      isValid,
      formattedNumber,
    }: {
      isValid: boolean;
      formattedNumber: string;
    }) {
      if (isValid) this.fallbackPhone = formattedNumber;
      else this.fallbackPhone = null;
    },
    setupAnswers(election: Election): void {
      this.answers = _.map(election.questions, q => [
        q.blank ? false : null,
        _.map(q.answers, () => false),
      ]);
    },
    async checkCodes(): Promise<void> {
      try {
        await this.$store.dispatch("submitBallot", {
          ballots: null,
          code: this.election?.code ? this.code : undefined,
          data: this.election?.data ? this.data : undefined,
          election: this.election,
          email: this.voter?.email,
        });
        this.next();
      } catch (e) {
        this.code = "";
        this.data = "";
        this.failure = e.message;
      }
    },
    async submit(): Promise<void> {
      const election = this.election;
      assert(election);
      const priv = this.priv;
      assert(priv);
      const voter = this.voter;
      assert(voter);

      try {
        this.status = this.$t("_vote.encrypting").toString();
        await sleep(400);
        const answers = _.map(this.answers, a => {
          const answers = _.map(a[1], a => (a ? 1 : 0));
          if (a[0] === null) return answers;
          if (a[0]) return [1].concat(_.map(a[1], () => 0));
          return [0].concat(answers);
        });
        const [ballot, fingerprint] = await encryptBallot(
          election,
          priv,
          answers
        );
        this.status = this.$t("_vote.submitting").toString();
        await this.$store.dispatch("submitBallot", {
          ballot,
          code: this.election?.code ? this.code : undefined,
          data: this.election?.data ? this.data : undefined,
          election,
          email: this.voter?.email,
        });
        this.ballot = window.URL.createObjectURL(
          new Blob([ballotFingerprint(ballot, election) + "\n"], {
            type: "text/plain",
          })
        );
        this.fingerprint = fingerprint;
      } catch (e) {
        this.failure = e.message;
      }
    },
    validate(step: number): boolean {
      assert(this.election);
      assert(this.answers);
      if (this.answers[step][0])
        //blank
        return true;
      const picks = this.picksCount(step);
      return (
        picks >= this.election.questions[step].min &&
        picks <= this.election.questions[step].max
      );
    },
  },
  name: "Vote",
  props: {
    uuid: { type: String, required: true },
  },
  watch: {
    election: {
      handler(election: Election): void {
        if (election) this.setupAnswers(election);
      },
      immediate: true,
    },
    voter: {
      handler(voter: Voter | null): void {
        if (voter) {
          const election = this.election;
          assert(election);
          if (this.$store.state.email && voter) {
            election.code = !!voter.code;
            election.data = !!voter.data;
          }
        }
      },
      immediate: true,
    },
    uuid: {
      async handler(uuid: string): Promise<void> {
        const state = this.$store.state;
        if (state.email === null && !state.elections?.has(uuid)) {
          return this.$store.dispatch("loadElection", {
            ballots: false,
            email: this.email,
            pub: this.pub,
            uuid,
          });
        }
      },
      immediate: true,
    },
  },
});
